import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "TypeScript", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Pug", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Pug + TypeScript", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import TsHelloWorld from './components/TypescriptHelloWorld.vue';
import PugHelloWorld from './components/PugHelloWorld.vue';
import Problem from './components/PugAndTypescriptHelloWorld.vue';

export default _defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(TsHelloWorld),
    _hoisted_2,
    _hoisted_3,
    _createVNode(PugHelloWorld),
    _hoisted_4,
    _hoisted_5,
    _createVNode(Problem),
    _hoisted_6
  ], 64))
}
}

})